module.exports = __webpack_public_path__ + "img/api-economy-product.630f1e9d.svg";